/** HTMLMediaElement MEDIA_ERR_SRC_NOT_SUPPORTED. */
export const MEDIA_ERR_SRC_NOT_SUPPORTED = 4;
const STORAGE_KEY = 'gs.blobVideoUnsupported';
/** Video failed before first frame; keeps the media error code for fallback decisions. */
export class VideoLoadError extends Error {
    code;
    constructor(code) {
        super(code === null ? 'Video load failed' : `Video load failed (media error ${code})`);
        this.code = code;
        this.name = 'VideoLoadError';
    }
}
export function isBlobUri(uri) {
    return uri.startsWith('blob:');
}
function defaultStorage() {
    try {
        return typeof localStorage === 'undefined' ? null : localStorage;
    }
    catch {
        return null;
    }
}
/** Remembered across restarts so Tizen-class TVs go straight to network video. */
export function readBlobVideoUnsupported(storage = defaultStorage()) {
    try {
        return storage?.getItem(STORAGE_KEY) === '1';
    }
    catch {
        return false;
    }
}
export function rememberBlobVideoUnsupported(storage = defaultStorage()) {
    try {
        storage?.setItem(STORAGE_KEY, '1');
    }
    catch {
        // Storage unavailable — the in-memory flag still covers this session.
    }
}
//# sourceMappingURL=video-source.js.map